import { render, staticRenderFns } from "./vipDraw.vue?vue&type=template&id=660bb1e8&scoped=true&"
import script from "./vipDraw.vue?vue&type=script&lang=js&"
export * from "./vipDraw.vue?vue&type=script&lang=js&"
import style0 from "./vipDraw.vue?vue&type=style&index=0&id=660bb1e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660bb1e8",
  null
  
)

export default component.exports